import MinersStatuses from "@components/global/new/MinersStatuses/MinersStatuses";
import { Panel } from "@components/global/new/Panel/Panel";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import { useLocationStatisticControl3 } from "@mobx/hooks/useLocationStatisticControl3";
import { useBuildingStatisticControl3 } from "@mobx/hooks/useObjectStatisticContro3l";
import { useWatchNetwork } from "@mobx/services/http";
import mainLocationsStore from "@mobx/store/locations";
import { MinerStatusInModal } from "@mobx/store/locations/types";
import { useAuth } from "@utils/hooks/useAuth";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { RingLoader } from "react-spinners";
import { SHOW_SCHEMES } from "../../../config";
import AdditionalRackFeatures3 from "../AdditionalRackFeatures3";
import AdditionalTitle3 from "../AdditionalTitle3";
import BuildingInfo3 from "../BuildingInfo3";
import BuildingMiners3 from "../BuildingMiners3";
import Buildings3 from "../Buildings3";
import ConnectionsEditor3 from "../ConnectionsEditor3";
import FilterClients3 from "../FilterClients3";
import Filters3 from "../Filters3";
import LocationChart3 from "../LocationChart3";
import RackTable3 from "../RackTable3";
import UnallocatedMiners3 from "../UnallocatedMiners3";
import styles from "./LocationMore.module.scss";
import React from "react";


// Oct: вынес в отдельный компонент для отладки, пока оставлю так
// внутри useLocationStatisticControl3 пришлось отказаться от стора, ибо вызывает дикие ре-рендеры
const LocationChartStandalone = React.memo((props: { locationID: number }) => {

  const { formatMessage } = useIntl();

  const locationStatisticControl = useLocationStatisticControl3(props.locationID);

  return (
    <LocationChart3 title={formatMessage({ id: "location.building.graph" })} control={locationStatisticControl} />
  );
});

export interface ILocationMore3Props {
  readonly locationID: number;
  readonly isOpen: boolean;
}

const useControl = (props: ILocationMore3Props) => {
  const locationStore = mainLocationsStore.locations[props.locationID];
  const buildingStore = locationStore?.activeBuilding;
  const auth = useAuth();
  const [showAvailableRacks, setShowAvailableRacks] = useState<boolean>(false);
  const [search, setSearch] = useState<string>();
  const [status, setStatus] = useState<MINER_STATUSES_E>();
  const isBuildingLoading = buildingStore?.isLoading;

  useWatchNetwork(buildingStore);
  const onShowAvailableRacks = () => setShowAvailableRacks((prev) => !prev);

  useEffect(() => {
    if (!props.isOpen || !buildingStore || buildingStore.isLoading) return;

    const nextSearch = search?.trim() ? search : undefined;
    const hasSameSearch = buildingStore.searchString === nextSearch;
    const hasSameStatus = buildingStore.statusFilter === status;

    if (buildingStore.isMinersStoreValid && hasSameSearch && hasSameStatus) {
      return;
    }

    buildingStore.search(nextSearch, status);
  }, [
    props.isOpen,
    buildingStore,
    buildingStore?.isLoading,
    buildingStore?.isMinersStoreValid,
    buildingStore?.searchString,
    buildingStore?.statusFilter,
    search,
    status,
  ]);

  // const locationStatisticControl = useLocationStatisticControl3({
  //   isOpen: props.isOpen,
  //   isAdmin: auth.isAdmin,
  // }, props.locationID);

  const objectStatisticControl = useBuildingStatisticControl3({
    isOpen: props.isOpen,
    isAdmin: auth.isAdmin,
  });

  const onOpenStatusesModal = (status: MinerStatusInModal) => {
    console.log("onOpenStatusesModal", status);
    buildingStore?.showStatusesModal(status, false);
  };

  const buildings = useMemo(() => locationStore?.buildingsInOrder.map(bs => bs.building), [locationStore?.buildingsInOrder]);

  return {
    //locationStatisticControl,
    objectStatisticControl,
    showAvailableRacks,
    isLoading: locationStore?.isLoading,
    isBuildingLoading,
    isFlipped: !!buildingStore?.isFlipped,
    activeBuildingID: buildingStore?.building.id,
    buildings,

    onShowAvailableRacks,
    onSearch(s: string, f?: string) {
      if (f === undefined) setStatus(undefined)
      else {
        const k = f as keyof typeof MINER_STATUSES_E;
        if (MINER_STATUSES_E[k] !== undefined) setStatus(MINER_STATUSES_E[k]);
        else setStatus(undefined);
      }
      setSearch(s);
    },
    onOpenModal: onOpenStatusesModal,
  };
};

const LocationMore3 = observer((props: ILocationMore3Props) => {

  const ctrl = useControl(props);
  const { formatMessage } = useIntl();

  const { ok, low, off } = useMemo(() => {
    const bld = ctrl.buildings ?? [];
    return bld.reduce(
      (acc, building) => {
        acc.ok += building.m_online || 0;
        acc.low += building.m_low || 0;
        acc.off += building.m_offline || 0;
        return acc;
      },
      { ok: 0, low: 0, off: 0 }
    );
  }, [ctrl.buildings]);

  if (ctrl.isLoading) {
    return <div className={styles.loader}>
      {/*<Loader transparent />*/}
    </div>
  }

  if (!props.isOpen) {
    return null;
  }

  console.log("LocationMore3 render", props);

  return (
    <div className={styles.wrap}>
      {ctrl.isBuildingLoading && (
        <div className={styles.buildingLoader}>
          <div className={styles.loaderContents}>
            <RingLoader size={100} />
          </div>
        </div>
      )}
      <MinersStatuses
        ok={ok}
        low={low}
        off={off}
        showTitle={false}
        className={styles.statuses}
        onClickStatuses={ctrl.onOpenModal}
      />
      {/* LocationChartStandalone рендерится всегда чтобы избежать unmount/remount при изменении isLoading */}
      {/*<div style={{ display: props.isOpen && !ctrl.isLoading ? undefined : "none" }}>*/}
      <Panel className={styles.container}>
        <LocationChartStandalone locationID={props.locationID} />
      </Panel>
      {/*</div>*/}

      {SHOW_SCHEMES && <Panel className={styles.container}>
        <ConnectionsEditor3 />
      </Panel>}

      <Buildings3 />
      {ctrl.activeBuildingID !== undefined && (
        <>
          <div className={styles.building_wrapper}>
            <BuildingInfo3 />
          </div>
          <Panel className={styles.container}>
            <LocationChart3 title={formatMessage({ id: "location.building.graph" })} control={ctrl.objectStatisticControl} />
          </Panel>
        </>
      )}

      <BuildingMiners3 />

      <div className={styles.filters}>
        <Filters3 onSearch={ctrl.onSearch} />

        <AdditionalTitle3
          show={ctrl.showAvailableRacks}
          onShow={ctrl.onShowAvailableRacks}
          rotate={ctrl.isFlipped}
        />
      </div>

      <div className={styles.data}>
        <RackTable3
          className={cn({
            [styles.show_shelving]: ctrl.showAvailableRacks,
          })}
        />
        <AdditionalRackFeatures3 show={ctrl.showAvailableRacks} />
      </div>

      <Panel className={styles.container}>
        <FilterClients3 />
      </Panel>

      <Panel className={styles.container}>
        <UnallocatedMiners3 />
      </Panel>
    </div>
  );
});

LocationMore3.displayName = "LocationMore3";

export default LocationMore3;
